<template>
  <article class="container">
    <section class="content mycheck_wrap">
      <div class="content_inner">
        <h1 class="logo_mc">
          <img src="@/assets/images/common/logo_mc.png" alt="multicampus">
        </h1>
        <div class="section_header mycheck_header" data-effect-slide="scroll">
          <h2 class="blind">본인인증</h2>
          <p class="text"><strong>수강정보</strong>를확인하시고 <br><strong>본인 확인</strong>을 진행해 주세요.</p>
        </div>
        <div class="section_content">
          <div class="check_my-info" data-effect-slide="scroll">
            <p class="info_title">{{ corsInfo.corsNm }}</p>
            <ul class="info_detail">
              <li class="info_schedule"><span class="blind">학습기간</span>
                <span class="txt">{{ corsInfo.eduStartDtm }} ~ {{ corsInfo.eduEndDtm }}</span>
              </li>
              <li class="info_time"><span class="blind">학습시간</span>
                <span class="txt">{{ corsInfo.lrnDseq }}일차, {{ corsInfo.eduStartTmHm }} ~ {{ corsInfo.eduEndTmHm }}</span>
              </li>
            </ul>
          </div>
          <div class="inp_group">
            <div
              class="inp_wrap type2"
              data-effect-slide="scroll">
              <!-- [D] 참고 : 유효성검사 걸린 경우 .input_box에 requirer를 추가 -->
              <div :class="{'is-active': focusOnPhone , 'requirer': errors.has('phoneNumber') }" class="input_box">
                <input
                  v-validate="'required'"
                  id="phoneNumber"
                  v-model="myCheck.phoneNumber"
                  :disabled="!isInputEnabledPhone"
                  name="phoneNumber"
                  type="number"
                  placeholder="휴대폰번호 입력"
                  title="휴대폰번호를 입력해 주세요."
                  class="inp"
                  maxlength="11"
                  @input="validatePhoneNumber"
                  @focus="focusOnPhone = true"
                  @blur="focusOnPhone = false">
                <div class="btn_wrap">
                  <button
                    :disabled="!button.isShowPhone"
                    :class="{'active' : myCheck.phoneNumber !='' && button.isShowPhone}"
                    type="button"
                    class="btn_basic btn--m_gray "
                    @click.stop="selectSendQrOtp"
                  >
                    <span class="btn_text" >{{ getPhoneTextBtn }}</span>
                  </button>
                </div>
              </div>
              <!-- [D] 참고 : 유효성검사 걸린 경우 .input_box에 requirer를 추가 -->
              <div :class="{'is-active': focusOnNum, 'requirer': errors.has('certiNumber') }" class="input_box">
                <input
                  v-validate="'required'"
                  id="certiNumber"
                  v-model="myCheck.certiNumber"
                  :disabled="!isInputEnabledOtp"
                  name="certiNumber"
                  type="number"
                  placeholder="인증번호 입력"
                  title="인증번호를 입력해 주세요."
                  class="inp"
                  maxlength="6"
                  @input="validateOtpNumber"
                  @focus="focusOnNum = true"
                  @blur="focusOnNum = false">
                <p v-if="otpTimer.timerRunning" class="time">{{ formatTime(otpTimer.timer) }}</p>
                <div class="btn_wrap">
                  <button
                    :disabled="!button.isShowOtp"
                    :class="{'active' : myCheck.certiNumber !='' && button.isShowOtp}"
                    type="button"
                    class="btn_basic btn--m_gray"
                    @click.stop="selectCheckCertOtp"
                  >
                    <span class="btn_text" >인증하기</span>
                  </button>
                </div>
              </div>
              <!--메시지-->
              <div v-for="(message) in toastMessages" v-show="message.show" :key="message.id" class="text_box">
                <p class="text_inner">
                  <i :class="message.icon"/>
                  <span class="text" v-html="message.text"/>
                </p>
              </div>
            </div>
          </div>
          <div class="check_btn-wrap" data-effect-slide="scroll">
            <div class="btn_wrap">
              <button
                :disabled="!button.isShowEnter"
                :class="{'active' : button.isShowEnter}"
                type="button"
                class="btn_check check-in"
                data-effect-event="click"
                data-effect-execute="true"
                @click.stop="updateCheckAtdnc('enter') ">
                <span class="btn_text" data-effect="check-in">입실하기</span>
              </button>
            </div>
            <div class="btn_wrap">
              <button
                :disabled="!button.isShowExit"
                :class="{'active' : button.isShowExit}"
                type="button"
                class="btn_check check-out"
                data-effect-event="click"
                data-effect-execute="true"
                @click.stop="updateCheckAtdnc('exit')">
                <span class="btn_text" data-effect="check-out">퇴실하기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>

import MotionEffects from '@/assets/js/MotionEffects'

export default {
  name: 'AttendAuth',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: QR출석체크'
    }
  },
  mixins: [MotionEffects],
  props: {
    param: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      params: {
        eduGrpCd: this.$route.query.eduGrpCd || 'CUS0001',
        corsCd: this.$route.query.corsCd,
        corsYr: this.$route.query.corsYr,
        corsDgrCd: this.$route.query.corsDgrCd,
        clssDgr: this.$route.query.clssDgr || '1',
        langCd: this.getUserLangCd(),
        lrnYmd: '',
        schdlSno: '',
        mbrNo: ''
      },
      corsInfo: {},
      atdncInfo: {},
      atdncType: '',
      mbrCelno: '',
      phoneNumber: '',
      mbrNo: '',
      userId: '',
      otpVal: '',
      myCheck: {
        phoneNumber: '',
        certiNumber: ''
      },
      otpTimer: {
        timer: 180,
        timerRunning: false
      },
      btnCnt: 0, // 재전송 판단
      isInputEnabledPhone: true,
      isInputEnabledOtp: true,
      button: {
        isShowPhone: false,
        isDisabledPhone: false,
        isShowOtp: false,
        isDisabledOtp: false,
        isShowEnter: false,
        isDisabledEnter: false,
        isShowExit: false,
        isDisabledExit: false
      },
      etcMessage: '',
      focusOnPhone: false,
      focusOnNum: false,
      toastMessages: [
        { id: 'noPhoneNumChk', show: false, icon: 'ico ico_warning', text: '휴대폰번호를 입력해 주세요.' },
        { id: 'phoneNumChk', show: false, icon: 'ico ico_warning', text: '휴대폰번호를 확인 후 다시 입력해 주세요.' },
        { id: 'otpNumChk', show: false, icon: 'ico ico_warning', text: '인증번호를 확인 후 다시 입력해 주세요.' },
        { id: 'sendOtp', show: false, icon: 'ico ico_check', text: '인증번호가 발송되었습니다.' },
        { id: 'enterType', show: false, icon: 'ico ico_check', text: '인증이 완료되었습니다.<br>입실하기 버튼을 클릭해주세요.' },
        { id: 'exitType', show: false, icon: 'ico ico_check', text: '인증이 완료되었습니다.<br>퇴실하기 버튼을 클릭해주세요.' },
        { id: 'etc', show: false, icon: 'ico ico_warning', text: '' }
      ]
    }
  },
  computed: {
    getPhoneTextBtn () {
      return (this.myCheck.phoneNumber !== '' && this.button.isShowPhone && this.btnCnt > 0) ? '재전송' : '인증요청'
    }
  },
  watch: {
    'myCheck.phoneNumber' (val) {
      if (!val) {
        this.showToast('noPhoneNumChk', true)
        this.button.isShowPhone = false
      } else if (val.length !== 11) {
        this.showToast('phoneNumChk', true)
        this.button.isShowPhone = false
      }
    },
    'myCheck.certiNumber' (val) {
      if (!val) {
        this.showToast('otpNumChk', false)
        this.button.isShowOtp = false
      } else if (val.length !== 6) {
        this.showToast('otpNumChk', true)
        this.button.isShowOtp = false
      }
    }
  },
  created () {
    this.selectQrCors()
  },
  beforeDestroy () {
  },
  mounted () {
  },
  methods: {
    selectQrCors () {
      if (Object.keys(this.$props.param).length > 0 && this.$props.param.corsInfo) {
        this.corsInfo = this.$props.param.corsInfo
        this.params.lrnYmd = this.corsInfo.lrnYmd
        this.params.schdlSno = this.corsInfo.schdlSno
        return
      }

      const params = {...this.params}
      this.$http.b2c.selectQrCors(this, params).then( result => {
        if (result.data.status === 'OK') {
          this.corsInfo = result.data.data.corsInfo
          this.params.lrnYmd = this.corsInfo.lrnYmd
          this.params.schdlSno = this.corsInfo.schdlSno
        }
      }).catch(err => {
        console.log(err.message)
      })
    },

    selectSendQrOtp () { // 인증요청
      if (!this.myCheck.phoneNumber) return

      this.button.isShowPhone = false

      this.showToast() // 토스트메시지 리셋

      const params = {
        ...this.params,
        mbrCelno: this.myCheck.phoneNumber
      }

      this.$http.b2c.selectSendQrOtp(this, params).then( result => {
        setTimeout(() => { // 이중 클릭 방지
          this.button.isShowPhone = true
        }, 500)

        if (result.data.status === 'OK') {
          this.handleOtpResult(result.data.data)

          // 로컬 / 개발 / 품질에서는 자동으로 OTP 번호 설정
          if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'stage') {
            this.myCheck.certiNumber = result.data.data.otpVal
            this.validateOtpNumber()
          }
        } else {
          this.handleOtpError(result.data.message)
        }
      }).catch(err => {
        console.log(err.message)
      })
    },

    selectCheckCertOtp () { // 인증하기
      if (!this.otpTimer.timerRunning) return

      // if (this.otpVal !== this.myCheck.certiNumber) {
      //   this.showToast('otpNumChk', true)
      //   return
      // }

      this.showToast() // 토스트메시지 리셋

      const params = {
        ...this.params,
        otpVal: this.myCheck.certiNumber
      }

      this.$http.b2c.selectCheckCertOtp(this, params).then( result => {
        this.handleCertOtpResult(result.data)
      }).catch(err => {
        console.log(err.message)
      })
    },

    updateCheckAtdnc (type) { // 출석 체크
      if (!type) return

      const params = {
        ...this.params,
        atdncType: type
      }

      this.$http.b2c.updateCheckAtdnc(this, params).then( result => {
        if (result.data.status === 'OK') {
          this.atdncInfo = result.data.data.atdncInfo
          this.navigateToAttendJoin(type)
        } else {
          this.handleFailedAttendanceCheck(type)
        }
      }).catch(err => {
        console.log(err.message)
      })
    },

    navigateToAttendJoin (type) {
      this.$router.push({
        name: 'AttendJoin',
        query: {
          atdncType: type
        },
        params: {
          atdncItems: this.atdncInfo,
          corsInfo: this.getCorsInfoParams(type)
        }
      })
    },

    handleFailedAttendanceCheck (type) {
      this.$goPage({
        name: 'AttendTimeCheck',
        query: {
          atdncType: type
        },
        params: {
          corsTimeChk: 'N',
          corsParams: this.params,
          corsInfo: this.corsInfo
        }
      })
    },

    getCorsInfoParams (type) {
      return {
        eduGrpCd: this.$route.query.eduGrpCd,
        corsYr: this.$route.query.corsYr,
        corsCd: this.$route.query.corsCd,
        corsDgrCd: this.$route.query.corsDgrCd,
        mbrNo: this.params.mbrNo,
        clssDgr: this.params.clssDgr,
        atdncType: type
      }
    },

    validatePhoneNumber () {
      const phoneNumberPattern = /01[0-9]{1}-?[0-9]{4}-?[0-9]{4}/
      // const phoneNumberPattern = /^01[0-9]-?([0-9]{3,4})-?([0-9]{4})$/
      if (!phoneNumberPattern.test(this.myCheck.phoneNumber)) {
        this.button.isShowPhone = false
        this.showToast('phoneNumChk', true)
      } else {
        this.button.isShowPhone = true
        this.showToast('phoneNumChk', false)
      }
    },
    /* formatPhoneNumber (event) {
      // 사용자가 입력한 값에서 숫자 이외의 문자를 제거
      let input = event.target.value.replace(/\D/g, '')

      // 특정 위치에 공백 추가
      if (input.length >= 3 && input.length < 7) {
        input = input.replace(/(\d{3})(\d+)/, '$1 $2')
      }

      if (input.length >= 7) {
        input = input.replace(/(\d{3})(\d{4})(\d+)/, '$1 $2 $3')
      }

      // 가공된 값을 phoneNumber에 할당하여 입력 필드에 반영
      this.myCheck.phoneNumber = input

      this.validatePhoneNumber()
    }, */
    validateOtpNumber () {
      const otpPattern = /^\d{6}$/ // 숫자 6자리
      if (!otpPattern.test(this.myCheck.certiNumber)) {
        this.button.isShowOtp = false
        this.showToast('otpNumChk', true)
      } else {
        this.button.isShowOtp = true
        this.showToast('otpNumChk', false)
      }
    },

    startTimer () {
      if (this.otpTimer.timerRunning) {
        // 타이머가 이미 실행 중이면 초기화
        this.resetTimer()
      }

      this.otpTimer.timerRunning = true
      this.otpTimer.timer = 180
      const interval = setInterval(() => {
        this.otpTimer.timer--
        if (this.otpTimer.timer === 0) {
          clearInterval(interval)
          this.otpTimer.timerRunning = false
          this.showToast('sendOtp', false)
          this.button.isShowOtp = false
          // this.button.isShowEnter = false
          // this.button.isShowExit = false
        }
      }, 1000)
      this.otpTimer.interval = interval
    },

    resetTimer () {
      this.otpTimer.timer = 180
      this.otpTimer.timerRunning = false
      clearInterval(this.otpTimer.interval)
      this.otpTimer.interval = null
    },

    formatTime (seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    },

    showToast (messageId, isShow, msg) {
      // 특정 토스트 메시지를 보이거나 숨기도록 상태 변경
      if (messageId) {
        this.toastMessages.forEach(message => {
          if (message.id === messageId) {
            message.show = isShow

            if (msg) {
              message.text = msg
            }
          } else if (message.id !== messageId && isShow === true) {
            message.show = false
          }
        })
      } else {
        this.toastMessages.forEach(message => {
          message.show = false
        })
      }
    },
    handleOtpResult (data) {
      // this.otpVal = data.otpVal
      this.params.mbrNo = data.mbrNo
      const resultYn = data.resultYn

      if (this.btnCnt > 0) { // 재전송일 경우 입실퇴실 버튼 비활성화
        this.button.isShowEnter = false
        this.button.isShowExit = false
      }

      if (resultYn === 'Y') {
        this.btnCnt++
        this.startTimer()
        this.showToast('sendOtp', true)
      } else {
        this.showToast('otpNumChk', true)
        this.button.isShowOtp = false
      }
    },

    handleOtpError (message) {
      this.button.isShowPhone = false
      this.showToast('etc', true, message)
    },

    handleCertOtpResult (data) {
      if (data.status === 'OK') {
        this.atdncType = data.data.atdncType
        const resultYn = data.data.resultYn

        if (resultYn === 'Y') {
          this.button.isShowPhone = false
          this.button.isShowOtp = false
          this.isInputEnabledPhone = false
          this.isInputEnabledOtp = false
          this.otpTimer.timerRunning = false
        }

        if (this.atdncType === 'enter' && resultYn === 'Y') {
          this.button.isShowEnter = true
          this.showToast('enterType', true)
        }

        if (this.atdncType === 'exit' && resultYn === 'Y') {
          this.button.isShowExit = true
          this.showToast('exitType', true)
        }
      } else {
        // this.otpTimer.timerRunning = false
        this.showToast('etc', true, data.message)
      }
    }
  }
}
</script>
<style scoped>
.container {padding-top:0;}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/attend/AttendAuth.vue